import { render, staticRenderFns } from "./page-footer.vue?vue&type=template&id=0ca5f96c&scoped=true"
import script from "./page-footer.vue?vue&type=script&lang=js"
export * from "./page-footer.vue?vue&type=script&lang=js"
import style0 from "./page-footer.vue?vue&type=style&index=0&id=0ca5f96c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca5f96c",
  null
  
)

export default component.exports